import { Link } from 'react-router-dom'

export default function DashboardEditor() {
  return (
    <div className="min-h-screen" style={{background:"linear-gradient(140deg, #0a1020 0%, #0f172a 40%, #0b2236 100%)"}}>
      <div className="max-w-7xl mx-auto px-6 py-10">
        <h1 className="text-3xl font-bold text-white mb-8">Panel Editor</h1>
        <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
          <Link to="/admin-productos" className="block bg-white/5 border border-white/10 rounded-2xl p-6 text-white hover:border-cyan-400/50">Gestionar Productos y Servicios</Link>
        </div>
      </div>
    </div>
  )
}
